import dynamic from 'next/dynamic';

// react-lottie pulls in lottie-web, which references `document` at import time
// and throws during SSR. Loading it through next/dynamic with ssr: false keeps
// it client-only. Import this wrapper instead of 'react-lottie' directly.
const Lottie = dynamic(() => import('react-lottie'), { ssr: false });

export default Lottie;
